import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/pro-solid-svg-icons'

type LinkCustomerProps = {
  customerQboId: string | undefined
  onClick: () => void
}

const LinkCustomer = ({ customerQboId, onClick }: LinkCustomerProps) => {
  return (
    <Button icon={<FontAwesomeIcon icon={faLink} />} onClick={onClick}>
      {customerQboId ? 'Unlink Customer' : 'Link Customer'}
    </Button>
  )
}

export default LinkCustomer
